module.exports = __webpack_public_path__ + "img/KE.4c47296e.png";